import { Box, Button, Typography, Grid } from '@material-ui/core';
import { useStyles } from '@pages/account/wishlists/create/index';
import { useContext, useEffect } from 'react';
import { TrackingContext } from '@components/providers/tracking';
import { useTranslation } from 'tools/i18n';


const CelebrationSelector = ({ onChange, onContinue, currentSelected }) => {
    const { t } = useTranslation(['account']);

    const options = [
        { id: 'wedding', label: t('wishlist-wizard-type-wedding') },
        { id: 'birthday', label: t('wishlist-wizard-type-birthday') },
        { id: 'christmas', label: t('wishlist-wizard-type-christmas') },
        { id: 'move', label: t('wishlist-wizard-type-moving') },
        //{ id: 'graduation', label: t('wishlist-wizard-type-graduation') },
        { id: 'baby', label: t('wishlist-wizard-type-baby') },
        { id: 'standard', label: t('wishlist-wizard-type-standard') },
    ];
    const classes = useStyles();
    const {actions: trackingActions} = useContext(TrackingContext);

    useEffect(() => {
        trackingActions.pageImpression('Create wishlist: Select type', 'create_wishlist');
    }, [])

    return (
        <Box className={classes.wrapper}>
            <Typography variant="h6" className={classes.description}>
                {t('wishlist-wizard-intro-title')}
            </Typography>

            <Box className={classes.divider} />

            <Typography variant="h5" className={classes.title}>
                {t('wishlist-wizard-intro-subtitle')}
            </Typography>

            <fieldset role="radiogroup" aria-label={t('wishlist-wizard-intro-subtitle')}>
                <Grid container className={classes.radioGroup}>
                    {options.map(option => (
                        <button
                            key={option.id}
                            type="button"
                            role="radio"
                            aria-checked={currentSelected?.type === option.id}
                            tabIndex={currentSelected?.type === option.id ? 0 : -1}
                            className={`${classes.radioButton} ${
                                currentSelected?.type === option.id ? classes.selected : ''
                            }`}
                            onClick={() => {
                                onChange(option.id);
                                onContinue();
                            }}
                            onKeyDown={e => {
                                if (e.key === ' ' || e.key === 'Enter') {
                                    e.preventDefault();
                                    setSelected(option.id);
                                }
                            }}
                        >
                            {option.label}
                        </button>
                    ))}
                </Grid>
            </fieldset>
        </Box>
    );
};

export default CelebrationSelector;
